import IActionsResolver from 'globx/dist/Store/Interfaces/IActionsResolver';

import IMedia from '../../../Player/Interfaces/IMedia';

import IMediaActions from './Interfaces/IMediaActions';
import Media         from './Media';

const resolveMediaActions: IActionsResolver<Media, IMediaActions> = (value: Media): IMediaActions => ({
    load(nextMedia: IMedia): void {
        Object.assign(value, new Media(), nextMedia);
    }
});

export default resolveMediaActions;